// src/components/BannerRecent.jsx
import React from "react";
import { CiCalendar, CiClock1 } from "react-icons/ci";
import bg1 from "../assets/images/life-bg.webp";

/* Helper: pick correct language text */
const pickLang = (value, lang) => {
  if (!value) return "";
  return typeof value === "object" ? value[lang] : value;
};

const BannerRecent = ({ post, language = "en" }) => {
  if (!post) return null;

  const bg = post.img || bg1;

  const title = pickLang(post.title, language);
  const category = pickLang(post.category, language);

  const style = {
  backgroundImage: `
    linear-gradient(
      rgba(0, 0, 0, 0.65),
      rgba(0, 0, 0, 0.65)
    ),
    url(${bg})
  `,
  backgroundSize: "cover",
  backgroundPosition: "center",
  height: "80vh",
  borderRadius: 2,
  display: "flex",
  alignItems: "center",
  color: "#fff",
};


  return (
    <div style={style} className="mb-4 position-relative banner-cons">
      <div className="banner-con">
        <h6 className="pageniation">{category}</h6>

        <h2 className="banner-text">{title}</h2>

        <p className="banner-time">
          <CiCalendar className="me-1" /> {post.date}
          <span className="me-3"></span>
          <CiClock1 className="me-1" /> {post.time}
        </p>
      </div>
    </div>
  );
};

export default BannerRecent;
